import Vue from 'vue';
import GAuth from 'vue-google-oauth2';
import Nl2br from 'vue-nl2br/dist/Nl2br';
// eslint-disable-next-line @typescript-eslint/ban-ts-ignore
// @ts-ignore
import VueMask from 'v-mask';
import { gauthOption } from '@/utils/config';
import { protectNumberInputsFromWheel } from '@/utils/numberInputWheel';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import { createProvider } from './vue-apollo';
import i18n from './i18n';

import axiosInterceptor from './interceptors/axios.interceptor';

axiosInterceptor(store);
protectNumberInputsFromWheel();

Vue.config.productionTip = false;

Vue.use(GAuth, gauthOption);
Vue.use(VueMask);

Vue.component('nl2br', Nl2br);

Vue.prototype.$bus = new Vue();

new Vue({
  router,
  store,
  vuetify,
  apolloProvider: createProvider(),
  i18n,
  render: (h) => h(App),
}).$mount('#app');
